import gql from 'graphql-tag';

export const SEARCH_PARTIES = gql`
  query searchParties($idValue: String!) {
    SearchParties(fullName:$idValue) {
      id,
      fullName
    }
  }
`;
